var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 7.2C4 6.35131 4.33714 5.53737 4.93726 4.93726C5.53737 4.33714 6.35131 4 7.2 4H16.8C17.6487 4 18.4626 4.33714 19.0627 4.93726C19.6629 5.53737 20 6.35131 20 7.2V16.8C20 17.6487 19.6629 18.4626 19.0627 19.0627C18.4626 19.6629 17.6487 20 16.8 20H7.2C6.35131 20 5.53737 19.6629 4.93726 19.0627C4.33714 18.4626 4 17.6487 4 16.8V7.2Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.20312 11.2002C10.3077 11.2002 11.2031 10.3048 11.2031 9.2002C11.2031 8.09563 10.3077 7.2002 9.20312 7.2002C8.09856 7.2002 7.20312 8.09563 7.20312 9.2002C7.20312 10.3048 8.09856 11.2002 9.20312 11.2002Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0239 12.4972L7.20312 20.0004H16.9095C17.73 20.0004 18.5169 19.6745 19.097 19.0943C19.6772 18.5142 20.0031 17.7273 20.0031 16.9068V16.8004C20.0031 16.4276 19.8631 16.2844 19.6111 16.0084L16.3871 12.4924C16.2369 12.3285 16.0541 12.1977 15.8505 12.1084C15.6468 12.0191 15.4268 11.9732 15.2045 11.9736C14.9821 11.9741 14.7623 12.0209 14.559 12.111C14.3558 12.2012 14.1735 12.3327 14.0239 12.4972V12.4972Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image_upload.fc1703769207b7ed0babc6d93f928e2e.svg";
export { ForwardRef as ReactComponent };